export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'cui-dashboard'
    },
    {
      name: 'Employees',
      url: '/employees',
      icon: 'cui-people'
    },
    {
      name: 'Agents',
      url: '/agents',
      icon: 'cui-user'
    },
    {
      name: 'Visitors',
      url: '/visitors',
      icon: 'cui-people'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'cui-people'
    },
    {
      name: 'Chits',
      url: '/chits',
      icon: 'cui-file'
    },
    {
      name: 'Accounts',
      url: '/accounts',
      icon: 'icon-notebook'
    },
    {
      name: 'ReceiptBook',
      url: '/receipts',
      icon: 'icon-notebook'
    },
    {
      name: 'Report',
      url: '/report',
      icon: 'icon-graph',
      children: [
        {
          name: 'Auction Report',
          url: '/report/auction',
          icon: 'icon-envelope-open'
        },
        {
          name: 'Collection Report',
          url: '/report/collection',
          icon: 'icon-doc'
        },
        {
          name: 'Dues Report',
          url: '/report/dues',
          icon: 'icon-wallet'
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/navigation.js